<ng-container *ngIf="post.video.file as media">
  <vjs-ivs-player
    class="ivs_video"
    [options]="
      media
        | videoOption
          : {
              autoPlay: autoPlay,
              muted: true,
              type: post?.video?.videoFile?.type,
              videoMode:videoMode
            }
    "
  ></vjs-ivs-player>
</ng-container>
